import { Component, inject } from '@angular/core';
import { PurchaseOrderTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PurchaseOrderTypeCreateDto,
  PurchaseOrderTypeDto,
  PurchaseOrderTypeExcelDownloadDto,
  PurchaseOrderTypeUpdateDto,
} from '../proxy/controlling/dtos/purchase-order-type';
import { PURCHASEORDERTYPE_CONFIG, PURCHASEORDERTYPE_FIELDS } from './purchase-order-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-purchase-order-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PurchaseOrderTypeService, ConfirmationService],
  templateUrl: './purchase-order-type.html',
  styleUrl: './purchase-order-type.scss',
})
export class PurchaseOrderType extends BaseCrudComponent<
  PurchaseOrderTypeDto,
  PurchaseOrderTypeCreateDto,
  PurchaseOrderTypeUpdateDto,
  PurchaseOrderTypeExcelDownloadDto
> {
  service = inject(PurchaseOrderTypeService);
  config = PURCHASEORDERTYPE_CONFIG;
  fields = PURCHASEORDERTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PurchaseOrderTypeDto): PurchaseOrderTypeUpdateDto {
    return {
      name: data.name,
      sapCode: data.sapCode,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PurchaseOrderType';
  }
}
